import * as React from 'react'
import { t as typy } from 'typy'
import { inject, observer } from 'mobx-react'
import { color } from 'style-value-types'

import Image from 'src/components/UI/Image/Image'
import LinkComponent from 'src/components/UI/LinkComponent/LinkComponent'
import Menu from 'src/components/Menu/Menu'

import styles from './BrandHeader.module.scss'
import { HamburgerStroke } from '../UI/Icon/Icon'
import { Above, Below } from '../UI/Breakpoints'
import CartButton from '../Cart/CartButton'
import Hamburger from '../Hamburger/Hamburger'

type Props = {
  brand: any
  ui?: any
  menu: any
  transparent: boolean
}

@inject('ui')
@observer
class BrandHeader extends React.Component<Props> {
  changeMenu = (menu: string) => {
    const { ui } = this.props

    if (ui.activeMenu === menu) {
      ui!.setActiveMenu('')
    } else {
      ui!.setActiveMenu(menu)
    }
  }

  render() {
    const { brand, ui, menu, transparent } = this.props
    if (!brand.released) {
      return null
    }

    const colorWhite = transparent && ui.activeMenu !== 'menu'
    const logo = colorWhite
      ? typy(brand, 'logotypeLight.fields.file.url').safeObject
      : typy(brand, 'logotypeDark.fields.file.url').safeObject
    const logoAlt = typy(brand, 'logotypeLight.fields.title').safeObject
    const backgroundClass =
      colorWhite === true
        ? styles.brandBackground
        : [styles.brandBackground, styles.whiteBackground].join(' ')

    return (
      <div className={styles.brandHeader + ' aino-main-header'}>
        <div className={backgroundClass}>
          <div className={styles.brandHeaderContent}>
            <div className={styles.menuSection}>
              <Hamburger white={colorWhite} />
              {brand.brandHeaderLinks &&
                brand.brandHeaderLinks.length > 0 &&
                brand.brandHeaderLinks.map((link: any, index: number) =>
                  link && link.fields && link.fields.slug ? (
                    <LinkComponent
                      className={colorWhite ? styles.white : ''}
                      key={'link' + index}
                      to={link.fields.slug}
                    >
                      {link.fields.title}
                    </LinkComponent>
                  ) : null
                )}
            </div>
            {logo && (
              <LinkComponent
                className={styles.logoWrapper}
                ariaLabel={`Go to ${brand.brand}`}
                onClick={() => this.changeMenu('')}
                to={brand.slug}
              >
                <Image
                  className={styles.logotype}
                  key={colorWhite ? 'white' : 'black'}
                  critical
                  src={logo}
                  alt={logoAlt}
                />
              </LinkComponent>
            )}
            <CartButton color={colorWhite ? '#ffffff' : '#121311'} />
          </div>
          <Menu activeBrand={true} menu={menu} />
        </div>
      </div>
    )
  }
}

export default BrandHeader
